module.exports = __webpack_public_path__ + "img/thumbnail-placeholder.7de12442.svg";